import React from 'react';
import { Row, Col } from 'antd';
import { CoursesCard } from './CoursesCard';
import coursesData from './CoursesData';

export const AllCatogries = () => {
    
    return (
        <div>
            <Row gutter={[16,16]}>
               {
                   coursesData.map((course)=> <Col>
                    <CoursesCard src={course.image} title={course.name} desc={course.desc} key={course.id} />
                </Col>)
               }
                
            </Row>
         
        </div>
    )
}